'use strict'

import axeptio from './axeptio';
import navMain from './nav-main';
import searchPopin from './search-popin';
import smoothScroll from './smooth-scroll';

export default function () {
    axeptio();
    navMain();
    searchPopin();
    smoothScroll();
}
